import { service } from '../utils/request';

export function getItems(params) {
    const { pageSize, page } = params
    return service({
        url: '/products',
        method: 'get',
        params: {
            pageSize,
            page,
            sort: '-uid'
        }
    });
}

export function createItem(data) {
    return service({
        url: '/products/create',
        method: 'post',
        data
    });
}

export function itemUpdate(id, data) {
    return service({
        url: 'products/update/' + id,
        method: 'post',
        data
    });
}

export function unitUpdate(id, data) {
    return service({
        url: 'products/unit/' + id,
        method: 'post',
        data
    });
}

export function deleteItem(id) {
    return service({
        url: 'item/' + id,
        method: 'delete'
    });
}